/**
 * Arabic and English — the same as the mobile app (Mobile/src/lib/i18n.js).
 *
 * The interface copy is keyed by its English text: T('Add to bag') returns
 * the English as written, or its Arabic when the site is in Arabic. Anything
 * without an entry falls back to English rather than showing a key.
 *
 * Switching language reloads the page. Direction, fonts and the copy held in
 * module-level constants are all settled once at startup — a live flip would
 * leave half the page mirrored and half not, as the app's own setting says.
 */
import AR_STRINGS from './i18n.ar';

export const LANG = (() => {
  try { return localStorage.getItem('lum_lang') === 'ar' ? 'ar' : 'en'; } catch { return 'en'; }
})();
export const AR = LANG === 'ar';
export const LOCALE = AR ? 'ar-QA' : 'en-GB';

if (typeof document !== 'undefined') {
  document.documentElement.lang = LANG;
  document.documentElement.dir = AR ? 'rtl' : 'ltr';
  if (AR) document.title = 'Lumière — عطور فاخرة في قطر | دار عطور الدوحة';
}

export const setLang = code => {
  try { localStorage.setItem('lum_lang', code); } catch {}
  window.location.reload();
};

/* Arabic-Indic digits in Arabic, as the Luxe kit sets them; unchanged in English. */
const AR_DIGITS = '٠١٢٣٤٥٦٧٨٩';
export const num = v => (AR ? String(v).replace(/\d/g, d => AR_DIGITS[+d]) : String(v));

/** T('Only {n} left', {n: num(3)}) — vars are inserted as given. */
export const T = (s, vars) => {
  let out = (AR && AR_STRINGS[s]) || s;
  if (vars) for (const k of Object.keys(vars)) out = out.split('{' + k + '}').join(vars[k]);
  return out;
};
